import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import { getCollectionYardVisitEventsSummary } from "../../../selectors/collectionYardVisitEvents";
import { DateBanner } from "./SingleBanners/DateBanner";
import { PriceBanner } from "./SingleBanners/PriceBanner";
import { WeightBanner } from "./SingleBanners/WeightBanner";

import styles from "./BannersComponent.module.scss";

export const BannersComponent: React.FC = () => {
  const { t } = useTranslation();
  const summary = useSelector(getCollectionYardVisitEventsSummary);
  if (!summary) {
    return null;
  }

  const { created, priceSum, wasteSum } = summary;
  const formattedDateTime = dayjs(created).format("DD. MM. YYYY HH:mm");

  return (
    <div className={styles.banners}>
      <DateBanner value={formattedDateTime} label={t("collectionYardVisitEvents.summary.visitEventsDate")} />
      <WeightBanner
        value={wasteSum}
        label={t("collectionYardVisitEvents.summary.visitEventsTotalNetWeight")}
        unit="kg"
      />
      <PriceBanner value={priceSum} label={t("collectionYardVisitEvents.summary.visitEventsTotalPrice")} unit="€" />
    </div>
  );
};
